import React, {useState} from "react";
import { getCardIcon } from "../../../utils/utils"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";

function IRCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);


    const {receita_federal_status} = props
    let initialExpand = receita_federal_status.flag === "positive"? false : true
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Situação na Receita Federal
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(receita_federal_status.flag)}
                </div>
                {receita_federal_status.fiscal_situation ?
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>: null                  
                }                    
            </div>
            {receita_federal_status.fiscal_situation ?
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    {receita_federal_status.fiscal_situation}
                </div>
            </Collapse> :null  
            }     
        </div>
        );
}


export default IRCard